<template>
  <div class="component-upload-image">
    <el-upload
        multiple
        :action="uploadImgUrl"
        list-type="picture-card"
        :on-success="handleUploadSuccess"
        :before-upload="handleBeforeUpload"
        :limit="limit"
        :on-error="handleUploadError"
        :on-exceed="handleExceed"
        ref="imageUpload"
        :on-remove="handleDelete"
        :show-file-list="true"
        :headers="headers"
        :data="fileData"
        :file-list.sync="fileList"
        :on-preview="handlePictureCardPreview"
        :class="{ hide: true }"
    >
      <i class="el-icon-plus"></i>
      <div slot="file" slot-scope="{ file }">
        <img
            class="el-upload-list__item-thumbnail"
            :src="
            file.url.indexOf('.mp4') > -1
              ? file.url + '?x-oss-process=video/snapshot,t_1000,m_fast'
              : file.url
          "
            alt=""
        />
        <span class="el-upload-list__item-actions">
          <span
              class="el-upload-list__item-preview"
              @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <span class="el-upload-list__item-delete" @click="handleDelete(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>

    <!-- 上传提示 -->
    <div class="el-upload__tip" slot="tip" v-if="showTip">
      请上传
      <template v-if="fileSize">
        大小不超过 <b style="color: #f56c6c;">{{ fileSize }}MB</b>
      </template>
      <template v-if="fileType">
        ,格式为 <b style="color: #f56c6c;">{{ fileType.join("/") }}</b>
      </template>
      的文件
    </div>

    <el-dialog
        :visible.sync="dialogVisible"
        title="预览"
        width="800"
        append-to-body
    >
      <img
          :src="
          dialogImageUrl.indexOf('.mp4') > -1
            ? dialogImageUrl + '?x-oss-process=video/snapshot,t_1000,m_fast'
            : dialogImageUrl
        "
          style="display: block; max-width: 100%; margin: 0 auto;"
      />
    </el-dialog>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import { Loading } from 'element-ui';
import ty from "../../utils/ty.vue";
let loadingInstance;
export default {
  props: {
    ImgScale: {
      type: String,
      default: "",
    },
    value: [String, Object, Array],
    // 图片数量限制
    limit: {
      type: Number,
      default: 5,
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 1024,
    },
    fileData: {
      type: Object,
      default: () => {},
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ["png", "jpg", "jpeg", "mp4"],
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true,
    },
    // 是否显示提示
    isIndex: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      number: 0,
      uploadList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      hideUpload: false,
      baseUrl:ty.apiurl,
      uploadImgUrl: ty.apiurl + "/common/uploadFileUrl", // 上传的图片服务器地址
      headers: { },
      fileList: [],
      loading:null,
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          // 首先将值转为数组
          const list = Array.isArray(val) ? val : this.value.split(",");
          // 然后将数组转为对象数组
          this.fileList = list.map((item) => {
            if (typeof item === "string") {
              if (item.indexOf(this.baseUrl) === -1) {
                item = { name: this.baseUrl + item, url: item };
              } else {
                item = { name: item, url: item };
              }
            }
            return item;
          });
        } else {
          this.fileList = [];
          return [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    },
  },
  mounted() {
    this.initDragSort();
  },
  methods: {
    initDragSort() {
      const el = this.$refs.imageUpload.$el.querySelectorAll(
          ".el-upload-list"
      )[0];
      Sortable.create(el, {
        onEnd: ({ oldIndex, newIndex }) => {
          console.log(oldIndex);
          console.log(newIndex);
          // 交换位置
          const arr = this.fileList;
          const page = arr[oldIndex];
          arr.splice(oldIndex, 1);
          arr.splice(newIndex, 0, page);
          this.$emit("input", this.listToString(arr));
        },
      });
    },
    // 上传前loading加载
    handleBeforeUpload(file) {
      if (file.name.indexOf(".mp4") > -1) {
        this.fileData.fileType = 1;
      }
      let isImg = false;
      if (this.fileType.length) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        isImg = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
      } else {
        isImg = file.type.indexOf("image") > -1;
      }

      if (!isImg) {
        this.$message({
          showClose: true,
          message:  `文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`,
          type: "info",
        });
        return false;
      }
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message({
            showClose: true,
            message: `上传文件大小不能超过 ${this.fileSize} MB!`,
            type: "info",
          });
          return false;
        }
      }
      loadingInstance = Loading.service({
        lock: true,
        text: '正在上传，请稍候...!',
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      this.number++;
    },
    // 文件个数超出
    handleExceed() {
      this.$message({
        showClose: true,
        message: `上传文件数量不能超过 ${this.limit} 个!`,
        type: "info",
      });

    },
    // 上传成功回调
    handleUploadSuccess(res, file) {
      if (res.code === 0) {
        this.uploadList.push({ name: res.fileName, url: res.msg });
        this.uploadedSuccessfully();
      } else {
        this.number--;
        loadingInstance.close()
        this.$message({
          showClose: true,
          message: res.msg,
          type: "info",
        });
        this.$refs.imageUpload.handleRemove(file);
        this.uploadedSuccessfully();
      }
    },
    // 删除图片
    handleDelete(file) {
      const findex = this.fileList.map((f) => f.name).indexOf(file.name);
      if (findex > -1) {
        this.fileList.splice(findex, 1);
        this.$emit("input", this.listToString(this.fileList));
      }
    },
    // 上传失败
    handleUploadError() {
      this.$message({
        showClose: true,
        message: '上传失败，请重试',
        type: "info",
      });
      loadingInstance.close()
    },
    // 上传结束处理
    uploadedSuccessfully() {
      if (this.number > 0 && this.uploadList.length === this.number) {
        this.fileList = this.fileList.concat(this.uploadList);
        this.uploadList = [];
        this.number = 0;
        this.$emit("input", this.listToString(this.fileList));
        loadingInstance.close()
      }
    },
    // 预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = "";
      separator = separator || ",";
      for (let i in list) {
        if (list[i].url) {
          strs += list[i].url.replace(this.baseUrl, "") + separator;
        }
      }
      return strs != "" ? strs.substr(0, strs.length - 1) : "";
    },
  },
};
</script>
<!--<style scoped >-->
<!--// .el-upload&#45;&#45;picture-card 控制加号部分-->
<!--::v-deep.hide .el-upload&#45;&#45;picture-card {-->
<!--  display: none;-->
<!--}-->
<!--// 去掉动画效果-->
<!--::v-deep .el-list-enter-active,-->
<!--::v-deep .el-list-leave-active {-->
<!--  transition: all 0s;-->
<!--}-->

<!--::v-deep .el-list-enter,-->
<!--.el-list-leave-active {-->
<!--  opacity: 0;-->
<!--  transform: translateY(0);-->
<!--}-->
<!--</style>-->
